import { TrackWithGeometry } from "@opstel/query/models/track";
import { BufferStop } from "./BufferStop";
import { Switch } from "./Switch";
import { Location } from "@opstel/query/models/location";

type InfrastructuresProps = {
  readonly location: Location;
  readonly trackLineWidth: number;
};

export const Infrastructures = ({ location, trackLineWidth }: InfrastructuresProps) => {
  return (
    <>
      {location.bufferStops.map((i) => (
        <BufferStop
          key={i.code}
          topoPoint={i.coordinate}
          associatedTrack={location.stablingInfraLookup[i.connection] as TrackWithGeometry}
          trackLineWidth={trackLineWidth}
        />
      ))}
      {[...location.junctions, ...location.crossings].map((i) => (
        <Switch key={i.code} topoPoint={i.coordinate} trackLineWidth={trackLineWidth} />
      ))}
    </>
  );
};
